export enum WeworkStatusEnum {
  Pending = 'pending',
  Verified = 'verified',
  UnVerified = 'un_verified',
  Fail = 'fail',
}
